



































import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment-timezone';
import * as _ from 'underscore';

import { dateRangeInfoType, parkingSpotInfoType } from '@/types/Common';


@Component
export default class ParkingSpotDetailsPopup extends Vue {   

    @Prop({required: true})
    spotInfo!: parkingSpotInfoType;
    
    @Prop({required: true})
    bookingDates!: dateRangeInfoType;

    dataReady=false

        
    
    mounted(){
        this.dataReady=false
        this.dataReady=true
    }

    public getNextAvailable(bookings){

        const sortedBookings = _.sortBy(bookings, 'end_date')

        const start = moment(this.bookingDates.startDate)
        const end = moment(this.bookingDates.endDate)
        let endTimeConflict = false;

        const diffHours: number[] = []
        for(const booking of sortedBookings){
            const bookingStartDate = moment(booking['start_date'])
            const bookingEndDate = moment(booking['end_date'])
            const duration = moment.duration(bookingEndDate.diff(start)).asHours()

            if(duration>=0)
                diffHours.push(duration) 
            else 
                diffHours.push(100000)

            if(end > bookingStartDate && end <= bookingEndDate)
                endTimeConflict = true;
        }
        const min = Math.min(...diffHours)
        const nextAvailDateIndex = diffHours.indexOf(min)

        for(let nextTimeInx=nextAvailDateIndex; nextTimeInx< (sortedBookings.length-1); nextTimeInx++){
            const endTimeFirst =  sortedBookings[nextTimeInx]['end_date']
            const startTimeNext = sortedBookings[nextTimeInx+1]['start_date']
            const endTimeNext = sortedBookings[nextTimeInx+1]['end_date']

            if(endTimeFirst!=startTimeNext){
                return {endTimeFirst:endTimeFirst, startTimeNext:startTimeNext, endTimeNext:endTimeNext, endTimeConflict:endTimeConflict}
            }
            else if(endTimeFirst==startTimeNext && nextTimeInx==(sortedBookings.length-2) ){
                return {endTimeFirst:endTimeNext, startTimeNext:null, endTimeNext:null, endTimeConflict:null}
            }
        }

        return {endTimeFirst:sortedBookings[nextAvailDateIndex]['end_date'], startTimeNext:null, endTimeNext:null, endTimeConflict:null}
    }

    closePopup(){        
        this.$emit('closePopover');
    }

}
